import parseISO from 'onyx-common/parseISO'

const strToDate = (str) => {
  return parseISO(str)
}

export default strToDate
